import type { IHeartBeatFetcher } from "../../network/fetchers/HeartBeatFetcher";
import type { ICurrentWindowStore } from "../window/ICurrentWindowStore";
import type { IUserSessionStore } from "../user/UserSessionStore";
import { fireAndForget } from "../../util/async/FireAndForget";
import { CurrentUserType } from "../../network/contracts/CurrentUserType";

export interface IHeartBeatStore {
    start(): void;
    stop(): void;
}

export class HeartBeatStore implements IHeartBeatStore {
    private readonly pulseIntervalTimeout: number = 2 * 1000 * 60; //2 minutes
    private pulseInterval: number | null = null;

    constructor(
        private readonly heartBeatFetcher: IHeartBeatFetcher,
        private readonly currentWindowStore: ICurrentWindowStore,
        private readonly userSessionStore: IUserSessionStore,
    ) {}

    start(): void {
        const { heartBeatFetcher: heart, currentWindowStore, userSessionStore } = this;
        const { currentWindow } = currentWindowStore;

        if (userSessionStore.currentUserType !== CurrentUserType.User) return;

        this.pulseInterval = currentWindow.setInterval(() => {
            fireAndForget(heart.pulse());
        }, this.pulseIntervalTimeout);
    }

    stop(): void {
        if (this.pulseInterval != null) {
            clearInterval(this.pulseInterval);
            this.pulseInterval = null;
        }
    }
}
